import * as a from '@mitranim/js/all.mjs'
import {E} from './util-view.mjs'
import * as c from './conf.mjs'
import * as ut from './util-text.mjs'
import * as uti from './util-time.mjs'
import * as uc from './util-coll.mjs'

export function timezonesToSelectables(timezones) {
  return a.map(timezones, timezoneToSelectable)
}

function timezoneToSelectable(val) {
  a.reqStruct(val)

  const {name} = val
  const offset = uti.secsToHours(val.utcOffset)

  return {
    value: name,
    title: name,
    getTitleMarkup() {
      return E(`div`, {class: `select-timezone`},
        E(`span`, {class: `select-timezone-name`}, name),
        E(`span`, {class: `select-timezone-info`},
          E(`span`, {}, val.abbreviation),
          E(`span`, {}, `(${ut.sign(offset)}${offset})`),
        )
      )
    },
  }
}

// TODO remove. Implement `isSelectable` on languages from `dat.languages`.
export function languagesToSelectables(vals) {
  return a.map(vals, languageToSelectable)
}

function languageToSelectable(val) {
  const {code, title} = a.reqStruct(val)
  return {value: code, title}
}

export function regDateSels(tzm) {
  const currentYear = uti.dateGetYear(Date.now(), tzm)
  return uc.timesBetween(c.START_YEAR, currentYear + 1, yearSel).reverse()
}

function yearSel(year) {
  return {
    value: ut.formatDateIso(uti.dateFromYear(year)),
    title: String(a.laxNat(year)),
  }
}

// TODO remove. Implement `isSelectable` on `Service`.
export function serviceToSelectable(val) {
  a.reqStruct(val)
  return {title: a.laxStr(val.title), value: a.reqPk(val.originId)}
}
